import { GenOrUse } from "./Product";
import { TranslateResult } from "vue-i18n";

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export function toHA(object: { [key: string]: any }, keys: string[]) {
    keys.forEach((key) => {
        const path = key.split(".");
        const lastKey = path.splice(path.length - 1, 1).join("");
        const ref = path.reduce((accum, k) => accum ? accum[k] : accum, object);
        if (ref === undefined) {
            console.warn(`Invalid path to object, ${key} points to undefined `);
        } else if (ref !== null) {
            // Ignore null objects
            const val = ref[lastKey];
            ref[lastKey] = val / 10000;
        }
    });
}

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export function toHAList(list: {[key: string]: any}[], keys: string[]): void {
    if(!list){
        return;
    }
    list.forEach(r => toHA(r, keys));
}

export function toPercentage(perc: number): string{
    // due to 0.56 * 100 gives 0.5655000001, damn javascript!
    return (Math.floor(perc * 10000) / 100) + "%";
}

export interface SummaryStep{
    component: string;
    isVisible?: boolean;
    type?: GenOrUse[];
}

export interface SelectionStep {
    component: string;
    isDisabled: boolean;
    title: string | TranslateResult;
    optional?: boolean;
    canNavigateToWarehouse?: boolean;
}

